import { faDownload, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import FileSaver from "file-saver";
import React, { useState } from "react";
import { Button, Stack, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { deleteNoteDocument, fetchNoteDocumentDownload, fetchNoteDocumentView } from "../../../../services/httpClient";
import { Note } from "../../../../types/note";
import IconEmbeddedButton from "../../../ui/IconEmbeddedButton";

interface NoteFilesState {
  documents: any;
  setDocuments: any;
  note?: Note;
  editNote?: boolean;
  myCase?: boolean;
  setIsLoading: any;
  setShowToast?: any;
  setToastText?: any;
  setToastBody?: any;
}

export const ViewNoteFiles = ({ documents, setDocuments, note, editNote = false, myCase = false, setIsLoading, setShowToast, setToastText, setToastBody }: NoteFilesState) => {
  const { id } = useParams();
  const [isDeleting, setIsDeleting] = useState(false);
  const [docToDelete, setDocToDelete] = useState<any>();

  const isSafariOniPad = () => {
    const ua = navigator.userAgent.toLowerCase();

    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

    const isSafari = /^((?!chrome|android).)*safari/.test(ua);
    const isiPad = /ipad/.test(ua) || (navigator.userAgent.includes("Macintosh") && isTouchDevice);

    return isiPad && isSafari;
  };

  const extensions = ["jpg", "JPG", "jpeg", "JPEG", "png", "PNG", "pdf", "PDF"];

  const onClickDownload = (docId: string, docName: string) => {
    fetchNoteDocumentDownload(id, note?.id, docId).then((res: any) => {
      FileSaver.saveAs(res[0].data, docName);
    });
  };

  const onClickView = (docId: string, docName: string) => {
    fetchNoteDocumentView(id, note?.id, docId).then((res: any) => {
      const blobUrl = URL.createObjectURL(res[0].data);
      window.open(blobUrl, "_blank");
    });
  };

  const renderDelete = () => {
    return (
      <tr>
        <td colSpan={1}>Are you sure you want to delete?</td>
        <td colSpan={2} className="text-end">
          <Button className="me-3 app-danger-color button" onClick={() => onClickDeleteFinal()}>
            Confirm Delete
          </Button>
          <Button className="app-primary-color button" onClick={() => onClickCancelDelete()}>
            Cancel
          </Button>
        </td>
      </tr>
    );
  };

  const onClickDeleteFinal = () => {
    setDocuments(
      documents.filter((d: any) => {
      if(d.id === docToDelete.id){
        return d.name !== docToDelete.name;
      } else {
        return d.id !== docToDelete.id;
      }
      })
    );
    if (editNote) {
      setIsLoading(true);
      deleteNoteDocument(id, note?.id, docToDelete.id)
        .then((res: any) => {
          setIsDeleting(false);
          setShowToast(true);
          setToastText("Note Document Deleted");
          setToastBody(docToDelete.name);
          setIsLoading(false);
        });
    }
  };

  const onClickDelete = (docId: string, docName: string) => {
    setIsDeleting(true);
    setDocToDelete({ id: docId, name: docName });
  };

  const onClickCancelDelete = () => {
    setIsDeleting(false);
    setDocToDelete(undefined);
  };


  return (
    <>
      <Table striped>
        <tbody>
          {(!documents || documents.length === 0) ? (
            <tr>
              <td colSpan={3}>
                <p className="mt-2 mb-0">No Note Documents</p>
              </td>
            </tr>
          ) : (
            documents.map((d: any) =>
              isDeleting && docToDelete && (docToDelete.id === d.id) && (docToDelete.name === d.name) ? (
                renderDelete()
              ) : (
                <tr key={d.id}>
                  <td>{d.name}</td>
                  <td className="text-end">
                    <Stack direction="horizontal" gap={2} className="justify-content-end">
                      {editNote && (
                        <>
                          {extensions.some((extension) => d.name.split(".").pop() === extension) && (
                            <IconEmbeddedButton
                              onClickButton={() => (isSafariOniPad() ? onClickDownload(d.id, d.name) : onClickView(d.id, d.name))}
                              tooltipText="View"
                              icon={faEye}
                              color="primary"
                            />
                          )}
                          <IconEmbeddedButton onClickButton={() => onClickDownload(d.id, d.name)} tooltipText="Download" icon={faDownload} />
                        </>
                      )}
                      {myCase && (
                        <IconEmbeddedButton
                          onClickButton={() => onClickDelete(d.id, d.name)}
                          tooltipText="Delete"
                          icon={faTrash}
                          color="danger"
                        />
                      )}
                    </Stack>
                  </td>
                </tr>
              )
            )
          )}
        </tbody>
      </Table>
    </>
  );
};
